import { DynamicOrder } from 'utils/dynamic';
import * as yup from 'yup';
import { ITenantIgnoreProduct } from '__generated__/api';

export type IgnoreProductInput = ITenantIgnoreProduct;
export const schemaIgnoreProduct = yup.object({
  serialNumber: yup.string().nullable().required('rule-required').trim().default(''),
  productName: yup.string().nullable().required('rule-required').trim().default(''),
});

export type IGridIgnoredProduct = ITenantIgnoreProduct;
export interface IGridIgnoredProductArgs {
  tenantID: string;
  search: string;
  take?: number;
  skip?: number;
  orderBy: DynamicOrder;
}
